/**
 * stli-quick-view.js — a second copy of bundle-cart's quickView (`e67e8c9`) — merging is a separate change with its own before/after.
 * Section 2 (`shop-the-look-inova`) only. Copied by `review-stli-14.9/scripts/stli_qv_copy.mjs` — renames only; every other line
 * with its reason in `review-stli-14.9/qv-copy-diff.txt`. Why a module: section 2's `{% javascript %}` is a plain bundle (head 32.0, shape i).
 */
import { StandardEvents } from '@shopify/events';

class StliQuickView extends HTMLElement {
  connectedCallback() {
    this.quickView();
  }

  /**
   * 🚨 פער 9 — *Quick view*, אחד לאחד עם `QuickView extends XModal extends ModalElement` של המקור (14.9.2026):
   * `regimes/out/bundle-cart-14.9/qv-src-classes.txt` · `qv-src-classes-2.txt` · `qv-src-xmodal.txt`; המדידה — `maps/bundle-cart.json`.
   *
   *   פתיחה   `open` · `hidden=false` · לגוף העמוד (`shouldAppendToBody`) · נעילת גלילה (`shouldLock`) · `active` אחרי 75ms ·
   *           `fetch` של עמוד המוצר, והתוכן נכנס 200ms אחרי התשובה · פוקוס לכותרת אחרי `transitionend` של השכבה
   *   סגירה   `Escape` (keyup) · השכבה · כפתור הסגירה · הכפתור שפתח · עדכון סל (`theme.pubsub cartUpdate` במקור) —
   *           בלי `active`; אחרי `transitionend` של השכבה: התוכן מתרוקן, `hidden`, חזרה למקום, שחרור, פוקוס לכפתור
   *   גרירה   מתחת ל-640, על הכותרת (`gesture-element`): הגיליון נגרר עד גובה − 50, השכבה `1 − y / גובה`;
   *           עזיבה מתחת ל-30% מהגובה — חוזר (והשכבה נשארת בשקיפות שבה עצרה, כמו במקור); מעל — יוצא למטה ונסגר
   *
   * ⚠️ **התוכן הוא הרשת של עמוד המוצר שלנו** (`[data-product-grid-content]`, כמו `quick-add.js` של הערכה) — במקור
   * `?view=modal` של עמוד המוצר שלו. מה שבה שונה ממה שבחלון של המקור — חריגה בשם, לאלעד.
   * ⚠️ **הנעילה:** במקור מונה (`lockLayerCount`) — סגירה אינה משחררת כשחלון אחר עדיין מחזיק (נמדד: חלונית הניוזלטר
   * של המקור השאירה את הדף נעול אחרי שהחלון הזה נסגר, `qv-lock*`, הראש 23.0). כאן `html[scroll-lock]` של הערכה —
   * ומשוחרר רק אם החלון הזה הוא שהוסיף אותו. ⛔ **אין כאן הגנה על *סגירה באמצע פתיחה*** — לא נמדד מנגנון כזה.
   */
  quickView() {
    const modal = this.querySelector('[data-stli-qv]');
    if (!modal) return;
    const inner = modal.querySelector('[data-stli-qv-inner]');
    const overlay = modal.querySelector('.stli__qv-overlay');
    const handle = modal.querySelector('[data-stli-qv-handle]');
    const content = modal.querySelector('[data-stli-qv-content]');
    const home = modal.parentElement;
    const root = document.documentElement;
    // `icon-arrow-right` של המקור, ה-viewBox והנתיב מילה במילה (`qv-src-modal-zenith.html`, אחרי `class="product__more"`);
    // הקו 1.5 — במקור מ-CSS: `.icon { stroke-width: var(--icon-weight) }`, נמדד 1.5px (`qv12-src-1440-r1`). היה ציור שלנו, 20×20 וקו 1.
    const ARROW = '<svg viewBox="0 0 21 20" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"/></svg>';
    // `icon-zoom` של המקור, הנתיב מילה במילה (`qv-src-modal-zenith.html`)
    const EXPAND = '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" d="M3 3V9M3 3H9M3 3L9 9M21 21V15M21 21H15M21 21L15 15"/></svg>';
    let opener = null;
    let abort = null;
    let activeTimer = 0;

    // `showTransition` / `hideTransition` של המקור: `transitionend` של השכבה, או מיד כשאין לה מעבר
    const overlayDone = () => new Promise((resolve) => {
      const cs = getComputedStyle(overlay);
      if (cs.transitionProperty === 'none' || !(parseFloat(cs.transitionDuration) > 0)) { resolve(); return; }
      overlay.addEventListener('transitionend', () => resolve(), { once: true });
      // mezuzi 172.0 #104: a cancelled transition ends it too - inside the cart, one Escape closes the cart under the window and its
      // overlay transition never ends (k/rec104d.mjs v1: the window was left [popover], open removed, never finished)
      overlay.addEventListener('transitioncancel', () => resolve(), { once: true });
    });
    let ownLock = false;

    // המשתנים של הסקשן יושבים על `<bundle-cart>` — בגוף העמוד החלון היה מאבד אותם
    const copyVars = () => {
      for (const name of this.style) if (name.startsWith('--stli')) modal.style.setProperty(name, this.style.getPropertyValue(name));
      const cs = getComputedStyle(this);
      for (const name of ['--stli-origin-start', '--stli-origin-end']) modal.style.setProperty(name, cs.getPropertyValue(name));
    };

    // `setInnerHTML` של המקור: סקריפטים שנכנסו כ-HTML אינם רצים עד שנוצרים מחדש
    const runScripts = (el) => {
      for (const old of el.querySelectorAll('script')) {
        const s = document.createElement('script');
        for (const a of old.attributes) s.setAttribute(a.name, a.value);
        s.textContent = old.textContent;
        old.replaceWith(s);
      }
    };

    // גרירה מטה — `ModalElement.onPanStart / onPanMove / onPanEnd` ו-`GestureElement` (screenY)
    const narrow = window.matchMedia('(max-width: 639px)');
    const g = { y0: null, moveY: 0, h: null, raf: 0 };
    const resetGesture = () => {
      inner.style.transform = '';
      inner.style.transition = '';
      overlay.style.opacity = '';
      overlay.style.transition = '';
    };

    // mezuzi 223.0 E4-1: the window's gallery tweaks, run on the imported grid AND again after a colour click - since E4 Tinker's
    // media-gallery replaces itself with the fetched page's gallery (pagination-position back, no expand buttons; probe_gallery.mjs)
    const tuneGallery = () => {
      content.querySelectorAll('slideshow-controls[pagination-position]').forEach((c) => c.removeAttribute('pagination-position'));
      const gallery = content.querySelector('media-gallery');
      content.querySelectorAll('slideshow-slide').forEach((slide, i) => {
        if (slide.querySelector(':scope > .stli__qv-expand')) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'stli__qv-expand';
        b.setAttribute('aria-label', `${modal.dataset.expandLabel || ''} ${i + 1}`.trim());
        b.innerHTML = EXPAND;
        b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); gallery?.zoom?.(i, e); });
        slide.append(b);
      });
    };
    content.addEventListener(StandardEvents.productSelect, (event) => {
      event.promise?.then(() => setTimeout(tuneGallery, 0)).catch(() => {});
    });

    const load = (url) => {
      abort?.abort();
      abort = new AbortController();
      const { signal } = abort;
      fetch(url, { signal })
        .then((r) => r.text())
        .then((html) => {
          setTimeout(() => {
            if (signal.aborted) return;
            const grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-grid-content]');
            if (!grid) { console.error('[stli-quick-view] quick view: no product grid in', url); hide(); return; }
            // #9: הרשת נושאת את מחלקות הפריסה של עמוד המוצר, וה-CSS של עמוד המוצר שהחלון נפתח בו פורס לפיהן את החלון (LEARNED שנג; הראש 34.0 על 501e4379)
            grid.classList.remove('product-information--media-right', 'product-information--media-left', 'product-information__grid--half');
            grid.querySelectorAll('slideshow-controls[pagination-position]').forEach((c) => c.removeAttribute('pagination-position'));
            const more = document.createElement('a');
            more.className = 'stli__qv-more';
            more.href = url;
            more.innerHTML = `<span></span>${ARROW}`;
            more.firstChild.textContent = modal.dataset.moreLabel || '';
            // mezuzi 223.0 E4 (Head 100.0): Tinker hooks a colour click with closest('.shopify-section, dialog') (media-gallery.js:20,
            // product-price.js:23, product-inventory.js:9, product-form.js:211); this window is a <div> moved to <body>, so nothing
            // listened - the picture and the form's variant id stayed on the first colour. The content box joins that lookup.
            content.classList.add('shopify-section');
            content.replaceChildren(document.importNode(grid, true), more);
            runScripts(content);
            // כפתור ההרחבה בכל שקופית — `button[is=media-lightbox-button]` של המקור (גלוי מתחת ל-1024 ב-CSS).
            // פותח את חלון ההגדלה של הערכה, אותו `media-gallery.zoom(i)` שהלחיצה על התמונה מגיעה אליו ב-1440.
            tuneGallery();
            handle.focus({ preventScroll: true });
          }, 200);
        })
        .catch((e) => { if (e.name !== 'AbortError') console.error(e); });
    };

    const show = (btn) => {
      if (modal.hasAttribute('open')) return;
      opener = btn;
      copyVars();
      modal.setAttribute('open', '');
      modal.hidden = false;
      modal.removeAttribute('inert');
      // mezuzi 172.0 #104: data-stli-qv-inplace (the cart's 'נצפו לאחרונה' rows) - the window stays where it is and opens in the
      // top layer: our cart is a native modal <dialog>, a window in <body> would sit behind it (review-172/READING-104d.md, k/pop104.mjs)
      if (this.hasAttribute('data-stli-qv-inplace')) { modal.popover = 'manual'; modal.showPopover(); }
      else if (modal.parentElement !== document.body) document.body.append(modal);
      ownLock = !root.hasAttribute('scroll-lock');
      root.setAttribute('scroll-lock', '');
      for (const b of this.querySelectorAll('[data-stli-qv-open]')) b.setAttribute('aria-expanded', String(b === btn));
      load(btn.dataset.url);
      activeTimer = setTimeout(() => modal.setAttribute('active', ''), 75);
      overlayDone().then(() => { if (modal.hasAttribute('open')) handle.focus({ preventScroll: true }); });
    };

    const hide = () => {
      if (!modal.hasAttribute('open')) return;
      clearTimeout(activeTimer);
      resetGesture();
      const wasActive = modal.hasAttribute('active');
      modal.removeAttribute('open');
      modal.setAttribute('inert', '');
      modal.removeAttribute('active');
      opener?.setAttribute('aria-expanded', 'false');
      const finish = () => {
        if (modal.hasAttribute('open')) return; // נפתח שוב בינתיים
        abort?.abort();
        content.replaceChildren();
        modal.hidden = true;
        if (modal.hasAttribute('popover')) { if (modal.matches(':popover-open')) modal.hidePopover(); modal.removeAttribute('popover'); } // 172.0 #104
        home.append(modal);
        if (ownLock) root.removeAttribute('scroll-lock');
        opener?.focus({ preventScroll: true });
      };
      if (wasActive) overlayDone().then(finish);
      else finish();
    };

    handle.addEventListener('touchstart', (e) => {
      if (!narrow.matches || !modal.hasAttribute('open')) return;
      g.y0 = e.changedTouches[0].screenY;
      g.moveY = 0;
      inner.style.transition = inner.style.transition.replace(/(^|,)\s*transform[^,]*/i, '');
      if (g.h === null) g.h = inner.getBoundingClientRect().height;
    }, { passive: true });

    handle.addEventListener('touchmove', (e) => {
      if (g.y0 === null) return;
      g.moveY = e.changedTouches[0].screenY - g.y0;
      if (g.raf) return;
      g.raf = requestAnimationFrame(() => {
        g.raf = 0;
        if (!modal.hasAttribute('open')) return;
        inner.style.transition = 'transform .1s linear';
        overlay.style.transition = 'opacity .1s linear';
        if (g.moveY >= 0) {
          inner.style.transform = `translateY(${Math.min(g.moveY, g.h - 50)}px)`;
          overlay.style.opacity = String(Math.min(1, Math.max(0, (g.moveY - g.h) / (0 - g.h))));
        } else {
          inner.style.transform = 'translateY(0)';
          inner.style.transition = '';
          overlay.style.opacity = '1';
        }
      });
    }, { passive: true });

    handle.addEventListener('touchend', () => {
      if (g.y0 === null) return;
      cancelAnimationFrame(g.raf);
      g.raf = 0;
      g.y0 = null;
      if (!modal.hasAttribute('open')) return;
      // 173.0 Q1 (Head 79.0): with reduced motion no .1s - and then no transitionend would ever come, so it closes at once
      const rmRelease = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      inner.style.transition = rmRelease ? 'none' : 'transform .1s linear';
      if (g.moveY < g.h * 0.3) inner.style.transform = 'translateY(0)';
      else {
        inner.style.transform = `translateY(${g.h}px)`;
        if (rmRelease) hide();
        else inner.addEventListener('transitionend', () => hide(), { once: true });
      }
    }, { passive: true });

    // מלכודת פוקוס — `theme.a11y.trapFocus` של המקור
    modal.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !modal.hasAttribute('open')) return;
      const list = [...modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.getClientRects().length);
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    for (const btn of this.querySelectorAll('[data-stli-qv-open]')) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (modal.hasAttribute('open')) hide();
        else show(btn);
      });
      this.hoverFill(btn);
    }
    // 183.0 #154: the fill on a button that does not open the quick view (the card's single-variant add-to-cart submit)
    for (const b of this.querySelectorAll('[data-stli-fill-only]')) this.hoverFill(b);
    modal.addEventListener('click', (e) => { if (e.target.closest('[data-stli-qv-close]')) hide(); });
    const close = modal.querySelector('.stli__qv-close');
    if (close) this.hoverFill(close);
    document.addEventListener('keyup', (e) => { if (e.code === 'Escape') hide(); });
    document.addEventListener(StandardEvents.cartLinesUpdate, () => hide());
  }

  hoverFill(btn) {
    const fill = btn.querySelector('[data-stli-fill]');
    if (!fill || !window.matchMedia('(any-hover: hover)').matches) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const go = (from, to) => {
      const start = from || getComputedStyle(fill).transform;
      for (const a of fill.getAnimations()) a.cancel();
      fill.animate([{ transform: start }, { transform: to }],
        { duration: reduced.matches ? 0 : 600, easing: 'ease', fill: 'forwards' });
    };
    btn.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'touch') go('translate3d(0, 76%, 0)', 'translate3d(0, 0, 0)');
    });
    btn.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'touch') go(null, 'translate3d(0, -76%, 0)');
    });
  }
}

if (!customElements.get('stli-quick-view')) {
  customElements.define('stli-quick-view', StliQuickView);
}
